import { render, staticRenderFns } from "./crIpfc2.vue?vue&type=template&id=c26aee6a"
import script from "./crIpfc2.vue?vue&type=script&lang=js"
export * from "./crIpfc2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports